<template>
  <v-dialog v-model="showPopup" persistent max-width="520">
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        {{title}}
      </v-card-title>
      <v-card-text>
        <p class="text-center" style="font-size: 16px;">{{message}}</p>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="ok"
          depressed
          class="save-btn small-size"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {
  MODULE_POPUP
} from '@/store/constant/mutation-types'

export default {
  name: 'SubmitFormErrorPopup',
  data() {
    return {
    }
  },
  computed: {
    showPopup() {
      return this.$store.getters[`${MODULE_POPUP}/showErrorSubmitFormPopup`]
    },
    title() {
      const data = this.$store.getters[`${MODULE_POPUP}/getErrorSubmitFormData`]
      return data.title
    },
    message() {
      const data = this.$store.getters[`${MODULE_POPUP}/getErrorSubmitFormData`]
      return data.message
    }
  },
  methods: {
    ok() {
      this.$store.dispatch('closeSubmitFormErrorPopup')
    }
  }
}
</script>

<style scoped>
</style>
